@if (dataLoading()) {
  <app-loading-animation class="padding"></app-loading-animation>
}

@if (clientInformation(); as ci) {
  <div class="information-container">
    <div class="content">
      <div class="col">
        <div class="row">
          <p class="row__detail-label">Name</p>
          <p class="row__detail-value" [appClientInformationRow]="ci.name"></p>
        </div>
        @if (ci.registeredNumber) {
          <div class="row">
            <p class="row__detail-label">Registered Number</p>
            <p class="row__detail-value" [appClientInformationRow]="ci.registeredNumber"></p>
          </div>
        }
        @if (ci.vatNumber) {
          <div class="row">
            <p class="row__detail-label">VAT Number</p>
            <p class="row__detail-value" [appClientInformationRow]="ci.vatNumber"></p>
          </div>
        }
        <div class="horizontal-divider"></div>
        <div class="row">
          <p class="row__detail-label">Jurisdiction</p>
          <p class="row__detail-value" [appClientInformationRow]="ci.jurisdiction"></p>
        </div>
        @if (ci.countryOfIncorporation) {
          <div class="row">
            <p class="row__detail-label">Country Of Incorporation</p>
            <p class="row__detail-value" [appClientInformationRow]="ci.countryOfIncorporation"></p>
          </div>
        }
      </div>
      <div class="vertical-divider"></div>
      <div class="col">
        <div class="row">
          <p class="row__detail-label">Administrative Office</p>
          @if (!ci.administrativeOfficeAddressEmpty) {
            <p class="row__detail-value" [appClientInformationRow]="ci.administrativeOfficeAddress"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.administrativeOfficeAddress2"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.administrativeOfficeCity"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.administrativeOfficeCounty"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.administrativeOfficeCountry"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.administrativeOfficePostCode"></p>
          } @else {
            <p class="row__detail-value row__detail-value--empty">(Empty)</p>
          }
        </div>
        <div class="row">
          <p class="row__detail-label">Registered Office</p>
          @if (!ci.registeredOfficeAddressEmpty) {
            <p class="row__detail-value" [appClientInformationRow]="ci.registeredOfficeAddress"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.registeredOfficeAddress2"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.registeredOfficeCity"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.registeredOfficeCounty"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.registeredOfficeCountry"></p>
            <p class="row__detail-value" [appClientInformationRow]="ci.registeredOfficePostCode"></p>
          } @else {
            <p class="row__detail-value row__detail-value--empty">(Empty)</p>
          }
        </div>
      </div>
    </div>
  </div>
}
